import TopAppBar, { AccountActionButton } from '../components/TopAppBar';
import Icon from '../components/Icon';
import { PLAY_STORE_URL } from '../lib/links';

/**
 * DictionaryView — read-only companion state.
 *
 * There is no /dictionary backend endpoint. Dictionary entries are authored
 * in the Loaf Android app and synced to the keyboard locally, so the web
 * companion explains the limitation instead of presenting an editor that
 * cannot save.
 */
export default function DictionaryView() {
  return (
    <>
      <TopAppBar
        title="Personal dictionary"
        breadcrumb={[{ label: 'Settings', to: '/app/settings' }]}
        actions={<AccountActionButton />}
      />

      <div className="mx-auto flex w-full max-w-max-width-content flex-1 flex-col gap-6 px-gutter pb-gutter pt-24 lg:flex-row">
        <div className="flex flex-1 flex-col space-y-6">
          <div>
            <p className="max-w-2xl font-body-md text-body-md text-on-surface-variant">
              Custom words help Loaf understand your unique vocabulary and technical terms.
            </p>
          </div>

          <div className="flex flex-1 flex-col items-center justify-center rounded-2xl border border-outline-variant/20 bg-surface-container-low p-12 text-center">
            <Icon
              name="library_books"
              className="mb-4 text-[64px] text-on-surface-variant"
            />
            <h2 className="font-headline-lg text-headline-lg text-on-surface">
              Manage your dictionary on Android
            </h2>
            <p className="mt-2 max-w-md font-body-md text-body-md text-on-surface-variant">
              The web companion cannot read or edit dictionary entries yet because no dictionary
              service is available here. Add custom words and shortcuts in the Loaf Android app.
            </p>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Open Loaf on Google Play"
              className="mt-6 flex h-[52px] items-center justify-center gap-2 rounded-xl bg-inverse-primary px-6 font-label-lg text-label-lg text-white transition-all hover:bg-primary-container active:scale-[0.98]"
            >
              <Icon name="android" />
              Open Loaf on Android
              <Icon name="open_in_new" className="text-[18px]" />
            </a>
          </div>
        </div>

        <aside className="w-full flex-shrink-0 lg:w-[400px]">
          <div className="sticky top-24 rounded-2xl bg-surface-container-low p-6">
            <div className="flex items-start gap-3">
              <Icon name="info" className="mt-0.5 text-primary" />
              <div>
                <h2 className="font-title-md text-title-md text-on-surface">
                  Read-only on the web
                </h2>
                <p className="mt-2 font-body-sm text-body-sm text-on-surface-variant">
                  Dictionary editing is available in the Loaf Android app. This page will remain
                  read-only until a web dictionary endpoint is added.
                </p>
              </div>
            </div>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex min-h-[44px] items-center gap-2 font-label-lg text-label-lg text-primary hover:underline"
            >
              Get Loaf on Google Play
              <Icon name="open_in_new" className="text-[18px]" />
            </a>
          </div>
        </aside>
      </div>
    </>
  );
}
